/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_LabelInputs */



/**
* | output |
* | --- |
* | "Theme" |
*
* @param {Profile_Theme_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_theme_label = /** @type {((inputs?: Profile_Theme_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Thème")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tema")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tema")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tema")
	return /** @type {LocalizedString} */ ("Theme")
});